import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../config";
import { FaArrowLeft } from 'react-icons/fa';
import axios from "axios";

export default function CheckoutPage() {
  const navigate = useNavigate();

  let tokenData;
  try {
    tokenData = JSON.parse(localStorage.getItem("authToken"));
  } catch (e) {
    tokenData = null;
  }
  const token = tokenData?.access;

  const [cart, setCart] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [locations, setLocations] = useState([]);
  const [orders, setOrders] = useState([]);
  const [viewOrders, setViewOrders] = useState(false); 
  const [form, setForm] = useState({ address: "", location: "", phone1: "", phone2: "" });
  const [loading, setLoading] = useState(false);

  const savedOrder = JSON.parse(localStorage.getItem("orderData")) || null;
  const reference = localStorage.getItem("paystack_ref");

  // 🔹 Auto Create Order if paystack_ref exists
  const CreateOrder = useCallback(async () => {
    if (!reference || !savedOrder) return;

    try {
      setLoading(true);

      console.log("📦 Sending order payload:", {
        reference,
        cart: savedOrder.cart,
        total_price: savedOrder.totalPrice,
        address: savedOrder.address,
        location: savedOrder.location,
        phone1: savedOrder.phone1,
        phone2: savedOrder.phone2,
      });

      const response = await axios.post(
        `${API_URL}/orders/`,
        {
          reference,
          cart: savedOrder.cart,
          total_price: savedOrder.totalPrice,
          address: savedOrder.address,
          location: savedOrder.location,
          phone1: savedOrder.phone1,
          phone2: savedOrder.phone2,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 201) {

        localStorage.removeItem("cart");
        localStorage.removeItem("orderData");
        localStorage.removeItem("paystack_ref");
        navigate("/cart");
      }
    } catch (err) {
      console.error("Error creating order:", err);
      localStorage.removeItem('cart');
      localStorage.removeItem('orderData');
      localStorage.removeItem('paystack_ref');

    } finally {
      setLoading(false);
    }
  }, [reference, savedOrder, token, navigate]);

  useEffect(() => {
    if (reference) {
      CreateOrder();
    }
  }, [reference, CreateOrder]);

  // 🔹 Load cart
  useEffect(() => {
    const savedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCart(savedCart);
  }, []);

  // 🔹 Fetch locations
  useEffect(() => {
    if (!token) return;
    axios
      .get(`${API_URL}/user-locations/`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setLocations(res.data))
      .catch((err) => console.error(err));
  }, [token]);

  // 🔹 Fetch orders
  useEffect(() => {
    if (viewOrders && token) {
      axios
        .get(`${API_URL}/orders/`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => setOrders(res.data))
        .catch((err) => console.error(err));
    }
  }, [viewOrders, token]);

  // 🔹 Sync cart to localStorage
  useEffect(() => {
    if (cart.length > 0) {
      localStorage.setItem("cart", JSON.stringify(cart));
    }
  }, [cart]);

  // handlers...
  const handleQuantity = (id, delta) => {
    setCart((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, quantity: Math.max(1, item.quantity + delta) }
          : item
      )
    );
  };
  const handleRemove = (id) => setCart((prev) => prev.filter((i) => i.id !== id));
  const totalPrice = cart.reduce((sum, i) => sum + i.price * i.quantity, 0);
  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleContinue = (e) => {
    e.preventDefault();
    const orderData = { cart, totalPrice, ...form };
    localStorage.setItem("orderData", JSON.stringify(orderData));
    navigate("/paystack-products");
  };

  const formatCurrency = (amount) => {
    try {
      return new Intl.NumberFormat("en-NG", {
        style: "currency",
        currency: "NGN",
        maximumFractionDigits: 2,
      }).format(amount);
    } catch {
      return `₦${amount.toFixed(2)}`;
    }
  };

  // 🔹 Show loading while auto-creating order
  if (loading) {
    return <div className="checkout-page"><p>Processing your order...</p></div>;
  }

  return (
    <div className="checkout-page">
      <header className="topbar">
        <button onClick={() => navigate(-1)} className="back-button" aria-label="Go back">
          <FaArrowLeft />
        </button>
        <h1 className="title">Checkout</h1>
      </header>

      {/* Switch between Orders and Checkout */}
      <div className="switch-bar" role="tablist">
        <button
          className={`pill ${!viewOrders ? 'active' : ''}`}
          onClick={() => setViewOrders(false)}
          role="tab"
          aria-selected={!viewOrders}
        >
          Checkout
        </button>
        <button
          className={`pill ${viewOrders ? 'active' : ''}`}
          onClick={() => setViewOrders(true)}
          role="tab"
          aria-selected={viewOrders}
        >
          My Orders
        </button>
      </div>

      {/* Orders View */}
      {viewOrders ? (
        <main className="content">
          <section className="panel orders">
            <h2 className="panel-title">My Orders</h2>
            {orders.length === 0 ? (
              <div className="empty-state">
                <p>You have no orders yet.</p>
              </div>
            ) : (
              <ul className="orders-list">
                {orders.map((order) => (
                  <li key={order.id} className="order-card">
                    <div className="order-meta">
                      <div>
                        <h3 className="order-product">{order.product?.name || 'Product'}</h3>
                        <p className="muted">Qty: {order.quantity}</p>
                        <p className="muted">Address: {order.address}</p>
                        <p className="muted">Phone: {order.phone1}{order.phone2 && `, ${order.phone2}`}</p>
                      </div>
                      <div className="status-col">
                        <span className={`status ${order.delivered ? 'delivered' : 'pending'}`}>
                          {order.delivered ? 'Delivered' : 'In progress'}
                        </span>
                        <small className="muted">Ordered on: {new Date(order.date_created).toLocaleString()}</small>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </section>
        </main>
      ) : (
        <main className="content">
          {/* Checkout View */}
          {cart.length === 0 ? (
            <section className="panel empty-panel">
              <h2>Your Cart is Empty</h2>
              <p className="muted">Browse products and add items to your cart to continue.</p>
            </section>
          ) : !showForm ? (
            <section className="checkout-grid">
              <div className="panel cart-panel">
                <h2 className="panel-title">Your Cart</h2>
                <div className="cart-list">
                  {cart.map((item) => (
                    <div key={item.id} className="cart-item">
                      <img src={item.image || 'https://via.placeholder.com/120'} alt={item.name} className="product-image" />
                      <div className="details">
                        <h3 className="product-name">{item.name}</h3>
                        <p className="product-price">{formatCurrency(item.price)}</p>

                        <div className="quantity">
                          <button aria-label="Decrease" onClick={() => handleQuantity(item.id, -1)} className="qty-btn">−</button>
                          <span className="qty-value">{item.quantity}</span>
                          <button aria-label="Increase" onClick={() => handleQuantity(item.id, 1)} className="qty-btn">+</button>
                        </div>
                      </div>

                      <div className="actions">
                        <p className="line-total">{formatCurrency(item.price * item.quantity)}</p>
                        <button className="icon-btn remove" onClick={() => handleRemove(item.id)} aria-label={`Remove ${item.name}`}>✕</button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <aside className="panel summary-panel">
                <h3 className="summary-title">Order Summary</h3>
                <div className="summary-row">
                  <span>Items</span>
                  <span>{cart.reduce((s, i) => s + i.quantity, 0)}</span>
                </div>
                <div className="summary-row total-row">
                  <strong>Total</strong>
                  <strong>{formatCurrency(totalPrice)}</strong>
                </div>

                <button className="confirm-btn" onClick={() => setShowForm(true)}>
                  Confirm and Checkout
                </button>

                <button className="secondary-btn" onClick={() => { setCart([]); }}>
                  Clear Cart
                </button>
              </aside>
            </section>
          ) : (
            <section className="panel form-panel">
              <h2 className="panel-title">Delivery Details</h2>
              <form onSubmit={handleContinue} className="checkout-form">
                <label className="label">Address</label>
                <input
                  type="text"
                  name="address"
                  value={form.address}
                  onChange={handleChange}
                  required
                />

                <label className="label">Location</label>
                <select
                  name="location"
                  value={form.location}
                  onChange={handleChange}
                  required
                >
                  <option  value="">-- Select Location --</option>
                  {locations.map((loc) => (
                    <option key={loc.id} value={loc.id}>
                      {loc.state}
                    </option>
                  ))}
                </select>

                <label className="label">Phone 1</label>
                <input
                  type="text"
                  name="phone1"
                  value={form.phone1}
                  onChange={handleChange}
                  required
                />

                <label className="label">Phone 2 (optional)</label>
                <input
                  type="text"
                  name="phone2"
                  value={form.phone2}
                  onChange={handleChange}
                />

                <div className="form-actions">
                  <button type="button" className="secondary-btn" onClick={() => setShowForm(false)}>Back</button>
                  <button type="submit" className="primary-btn">Continue to Payment</button>
                </div>
              </form>
            </section>
          )}
        </main>
      )}

      <style>{`
        :root{
          --bg: #f4f7fb;
          --card: #ffffff;
          --muted: #6b7280;
          --accent: #0ea5a4; /* teal 500 */
          --accent-2: #065f60; /* darker */
          --danger: #ef4444;
          --success: #16a34a;
          --glass: rgba(255,255,255,0.6);
          --shadow: 0 6px 20px rgba(16,24,40,0.08);
          --radius: 14px;
          font-family: Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
        }

        .checkout-page{
          min-height: 100vh;
          padding: 28px 20px;
          background: linear-gradient(180deg, #f8fafc 0%, #eef2f6 100%);
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .topbar{
          width: 100%;
          max-width: 1120px;
          display: flex;
          align-items: center;
          gap: 16px;
          margin-bottom: 18px;
        }

        .back-button{
          border: none;
          background: var(--card);
          padding: 10px;
          border-radius: 10px;
          box-shadow: var(--shadow);
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          transition: transform .14s ease, box-shadow .14s ease;
        }
        .back-button:hover{ transform: translateX(-3px); }
        .back-button:focus{ outline: 2px solid rgba(14,165,164,0.16); }

        .title{
          font-size: 20px;
          font-weight: 700;
          color: #0f172a;
        }

        .switch-bar{
          width: 100%;
          max-width: 1120px;
          display: flex;
          gap: 12px;
          align-items: center;
          margin-bottom: 22px;
          justify-content: center;
        }

        .pill{
          padding: 10px 18px;
          border-radius: 999px;
          border: 1px solid transparent;
          background: transparent;
          cursor: pointer;
          font-weight: 600;
          color: var(--muted);
          transition: all .18s ease;
        }
        .pill.active{
          background: linear-gradient(90deg, var(--accent), var(--accent-2));
          color: white;
          box-shadow: 0 8px 30px rgba(6,95,96,0.12);
          border-color: rgba(255,255,255,0.06);
        }

        .content{
          width: 100%;
          max-width: 1120px;
        }

        .panel{
          background: var(--card);
          border-radius: 14px;
          padding: 18px;
          box-shadow: var(--shadow);
        }

        .panel-title{
          margin: 0 0 12px 0;
          font-size: 18px;
          color: #0f172a;
        }

        /* Orders */
        .orders-list{ display: grid; gap: 12px; }
        .order-card{
          padding: 14px;
          border-radius: 12px;
          border: 1px solid rgba(15,23,42,0.04);
          background: linear-gradient(180deg, rgba(255,255,255,0.92), rgba(250,250,250,0.9));
        }
        .order-meta{ display: flex; justify-content: space-between; gap: 12px; align-items: center; }
        .order-product{ margin:0; font-size: 16px; }
        .muted{ color: var(--muted); font-size: 13px; }

        .status{ padding: 8px 12px; border-radius: 999px; font-weight: 700; font-size: 13px; }
        .status.delivered{ background: rgba(16,185,129,0.12); color: var(--success); }
        .status.pending{ background: rgba(250,204,21,0.08); color: #f59e0b; }

        /* Checkout grid */
        .checkout-grid{
          display: grid;
          gap: 18px;
        }

        @media(min-width:900px){
          .checkout-grid{ grid-template-columns: 1fr 360px; align-items: start; }
        }

        .cart-panel{ padding-bottom: 18px; }
        .summary-panel{ margin-top: 8px; display:flex; flex-direction:column; gap:14px; padding:20px; }

        .cart-list{ display:flex; flex-direction:column; gap:12px; }
        .cart-item{
          display: grid;
          grid-template-columns: 100px 1fr 88px;
          gap: 12px;
          align-items: center;
          padding: 12px;
          border-radius: 12px;
          border: 1px solid rgba(15,23,42,0.04);
          background: linear-gradient(180deg, rgba(255,255,255,0.85), rgba(250,250,250,0.85));
        }

        .product-image{ width: 100%; height: 74px; object-fit: cover; border-radius: 10px; }
        .product-name{ margin: 0 0 6px 0; font-size: 15px; }
        .product-price{ margin:0; color: var(--muted); font-size: 13px; }

        .quantity{ display:flex; gap:8px; align-items:center; margin-top:8px; }
        .qty-btn{
          padding: 6px 10px; border-radius: 8px; border: 1px solid rgba(15,23,42,0.06); background: transparent; cursor:pointer; font-weight:700; font-size:16px;
        }
        .qty-value{ min-width:26px; text-align:center; display:inline-block; }

        .actions{ display:flex; flex-direction:column; align-items:flex-end; gap:8px; }
        .line-total{ font-weight:700; }
        .icon-btn{ background:transparent; border:none; cursor:pointer; font-size:16px; padding:6px; border-radius:8px; }
        .remove{ color:var(--danger); }

        .summary-title{ margin:0; }
        .summary-row{ display:flex; justify-content:space-between; align-items:center; font-size:15px; color:var(--muted); }
        .total-row{ font-size:18px; color:#0f172a; }

        .confirm-btn{
          width:100%; padding:12px 14px; border-radius:10px; border:none; cursor:pointer; font-weight:700; font-size:15px;
          background: linear-gradient(90deg, var(--accent), var(--accent-2)); color:white; box-shadow: 0 8px 24px rgba(6,95,96,0.14);
        }
        .confirm-btn:hover{ transform: translateY(-2px); }

        .secondary-btn{
          width:100%; padding:10px 12px; border-radius:10px; border:1px solid rgba(15,23,42,0.06); background:transparent; cursor:pointer; font-weight:600;
        }

        /* Form */
        .form-panel{ max-width:700px; margin: 0 auto; }
        .checkout-form{ display:flex; flex-direction:column; gap:12px; }
        .label{ font-weight:600; font-size:14px; margin-bottom:6px; }
        input[type=text], select{
          padding:12px 14px; border-radius:10px; border:1px solid rgba(15,23,42,0.06); background:linear-gradient(180deg,#fff,#fafafa); font-size:14px;
        }

        .form-actions{ display:flex; gap:12px; justify-content:flex-end; margin-top:8px; }

        .empty-panel{
          padding: 48px; text-align:center;
        }

        /* small screens */
        @media(max-width:899px){
          .cart-item{ grid-template-columns: 84px 1fr auto; }
          .summary-panel{ order: 2; }
        }

      `}</style>
    </div>
  );
}
